import type { ComponentProps } from 'react';

interface Props extends ComponentProps<'div'> {
  title: string;
  subTitle?: string;
  className?: string;
}

const FullViewLoading = ({ title, subTitle, className, ...props }: Props) => {
  return (
    <div {...props} className={`flex h-full max-h-full w-full ${className}`}>
      <div className="m-auto">
        <div>
          <h3>{title}</h3>
          <h4>{subTitle}</h4>
        </div>
      </div>
    </div>
  );
};

export default FullViewLoading;
